// extracted by mini-css-extract-plugin
export default {"statusDot":"pool-detail_statusDot__hno2N"};